export default __webpack_public_path__ + "static/IN-8015HD-vs-IN-6012HD-9dc3e1bec6f6dd2ee5120a388d242f64.webp";